import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBase } from "mobx-stores/_models/base";
import { WorkOrder } from "mobx-stores/_models/work-order/work-order";
import { WorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { Material } from "../material";

export const MaterialGoodsIssueItem = types
  .compose(
    Base,
    types.model({
      materialId: types.maybeNull(types.string),
      material: types.maybeNull(Material),
      workOrderId: types.maybeNull(types.string),
      workOrder: types.maybeNull(WorkOrder),
      workOrderPOId: types.maybeNull(types.string),
      workOrderPO: types.maybeNull(WorkOrderPo),
      department: types.maybeNull(types.string),
      amount: types.maybeNull(types.number),
      batchProduction: types.maybeNull(types.string),
      brand: types.maybeNull(types.string),
      note: types.maybeNull(types.string),
    }),
  )
  .actions(withSetPropAction);
export interface IMaterialGoodsIssueItem extends Instance<
  typeof MaterialGoodsIssueItem
> {}
export interface IMaterialGoodsIssueItemProperties extends SnapshotIn<
  typeof MaterialGoodsIssueItem
> {}

export interface IAddMaterialGoodsIssueItem extends Omit<
  IMaterialGoodsIssueItemProperties,
  "material" | keyof IBase
> {}

export interface IUpdateMaterialGoodsIssueItem extends Omit<
  IMaterialGoodsIssueItemProperties,
  "material"
> {}
